import React from 'react';
import PropTypes from 'prop-types';
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import { Card, CardHeader, CardText } from 'material-ui/Card';
import IconEdit from 'material-ui/svg-icons/content/create';
import IconDelete from 'material-ui/svg-icons/action/delete';
import IconRestore from 'material-ui/svg-icons/action/settings-backup-restore';
import { Link, withRouter } from 'react-router';
import nl2br from '../../../helpers/nl2br';
import stripTags from '../../../helpers/stripTags';
import sortArray from '../../../helpers/sortArray';
import _ from 'lodash';
import moment from 'moment';

import IconMenu from 'material-ui/IconMenu';
import MenuItem from 'material-ui/MenuItem';
import IconButton from 'material-ui/IconButton';
import MoreHorizIcon from 'material-ui/svg-icons/navigation/more-horiz';
import Dialog from 'material-ui/Dialog';
import FlatButton from 'material-ui/FlatButton';

import classes from './Company.scss';

import ProjectTableEmbed from '../../../components/ProjectTable/ProjectTable';
import FileTable from '../../../components/FileTable/FileTable';
import TaskList from '../../../components/TaskList';
import ContactCard from '../../../components/ContactCard/ContactCard';
import { Address } from '../../../components/Address/Address';
import { DetailField } from '../../../components/DetailField/DetailField';
import ActivityTableEmbed from '../../../components/ActivityTableEmbed/ActivityTableEmbed';
import { simplImageUrl } from '../../../api/simplApi';
import { renderTabCount } from '../../../helpers/renderTabCount';

import companyStrings from '../../../locales/company/de.json';
import contactDetailsStrings from '../../../locales/contactDetails/de.json';
import FormFileUpload from '../../../components/FormFileUpload/FormFileUpload';

class Company extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      alert: null,
      selectedIndex: 0,
      selectedBankId: null,
      bankDetailDialogOpen: false,
      selectedPlaceId: null,
      placeDetailDialogOpen: false,
    };
  }

  componentWillMount() {
    this.props.setCompany(this.props.params.company);
  }

  componentDidMount() {
    this.props.fetchCompany(this.props.params.company);
  }

  handleSelect = index => {
    this.setState({ selectedIndex: index });
  };

  handleAlertClose = () => {
    this.setState({
      alert: null,
    });
  };

  renderMenuItems = () => {
    if (this.props.company.deleted_at === null) {
      return [
        <MenuItem
          primaryText="Unternehmen bearbeiten"
          leftIcon={<IconEdit className="svg-icon-primary" />}
          key="editCompany"
          className="menu-primary"
          onClick={() => {
            this.props.setCompanyForm(this.props.company.id);
          }}
        />,
        <MenuItem
          primaryText="Unternehmen löschen"
          leftIcon={
            <IconDelete className="svg-icon-primary svg-icon-warning" />
          }
          key="delCompany"
          className="menu-primary"
          onClick={() => {
            this.setState({
              alert: (
                <Dialog
                  actions={[
                    <FlatButton
                      label="Abbrechen"
                      primary
                      onTouchTap={this.handleAlertClose}
                    />,
                    <FlatButton
                      label="Löschen"
                      primary
                      onTouchTap={() => {
                        this.handleAlertClose();
                        this.props.deleteCompany(this.props.company.id); // this.props.push('/company');
                        this.props.router.push('/company');
                      }}
                    />,
                  ]}
                  modal={false}
                  open
                  onRequestClose={this.handleAlertClose}
                >
                  Unternehmen wirklich löschen?
                </Dialog>
              ),
            });
          }}
        />,
      ];
    } else {
      return [
        <MenuItem
          primaryText="Unternehmen wiederherstellen"
          leftIcon={
            <IconRestore className="svg-icon-primary svg-icon-warning" />
          }
          key="delCompany"
          className="menu-primary"
          onClick={() => {
            this.setState({
              alert: (
                <Dialog
                  actions={[
                    <FlatButton
                      label="Abbrechen"
                      primary
                      onTouchTap={this.handleAlertClose}
                    />,
                    <FlatButton
                      label="Wiederherstellen"
                      primary
                      onTouchTap={() => {
                        this.handleAlertClose();
                        this.props.restoreObject(
                          encodeURIComponent('App\\Company'),
                          this.props.company.id,
                        );
                        this.props.fetchCompany(this.props.params.company);
                      }}
                    />,
                  ]}
                  modal={false}
                  open
                  onRequestClose={this.handleAlertClose}
                >
                  Unternehmen wirklich wiederherstellen?
                </Dialog>
              ),
            });
          }}
        />,
      ];
    }
  };

  renderHeader = () => (
    <header>
      <ul className="breadcrumbs">
        <li>
          <Link to="/company" activeClassName={classes.activeRoute}>
            {this.props.companyCount} Unternehmen
          </Link>
        </li>
        <li>
          {this.renderLogo(100, 28, 'contain')}
          {this.props.company.name}
          {this.props.company.deleted_at === null ? (
            ''
          ) : (
            <span className="deletedTag">gelöscht</span>
          )}
        </li>
      </ul>
      <IconMenu
        iconButtonElement={
          <IconButton>
            <MoreHorizIcon />
          </IconButton>
        }
        anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
        targetOrigin={{ horizontal: 'right', vertical: 'top' }}
        className="overflow-right"
      >
        {this.renderMenuItems()}
      </IconMenu>
      {this.state.alert}
    </header>
  );
  renderContacts = () => {
    const contacts = [];

    let orderedContacts = _.orderBy(this.props.persons, ['name'], ['asc']);

    _.forOwn(orderedContacts, value => {
      // create new object that will be handled by griddle
      const sortedDetails = _.sortBy(value.contact_details, [
        'sortedByType',
        'created_at',
      ]);

      const email = _.find(sortedDetails, ['type', 'email']);
      const phone = _.find(sortedDetails, ['type', 'tel']);
      const mobile = _.find(sortedDetails, ['type', 'mobile']);
      const position = _.find(value.meta, ['key', 'position']);
      contacts.push(
        <ContactCard
          name={value.name}
          number={phone ? phone.value : null}
          mobile={mobile ? mobile.value : null}
          email={email ? email.value : null}
          position={position ? position.value : null}
          avatar={value.avatar}
          key={`contactcard_${value.id}`}
          type="person"
          displayType="card"
          id={value.id}
        />,
      );
    });
    if (contacts.length === 0) {
      return (
        <section>
          <h2>0 Kontakte</h2>
          <div>
            <p className="text-center">
              <small>Keine Kontakte eingetragen.</small>
            </p>
          </div>
        </section>
      );
    }
    return (
      <section>
        <h2>{renderTabCount(this.props.persons, true)} Kontakte</h2>
        <div className="row">{contacts}</div>
      </section>
    );
  };
  renderPlaces = () => {
    const companyAddresses = [];
    const storeAddresses = sortArray(
      this.props.company.company_addresses,
      'title',
      false,
      true,
    );
    if (typeof storeAddresses === 'undefined' || storeAddresses.length === 0) {
      return (
        <p className="text-center">
          <small>Dieses Unternehmen hat noch keine Standorte.</small>
        </p>
      );
    }
    storeAddresses.forEach((place, index) => {
      if (place.title.length === 0) {
        return;
      }
      const address =
        typeof place.address !== 'undefined' && place.address !== null ? (
          <Address address={place.address} />
        ) : null;
      companyAddresses.push(
        <div className="col-xs-12 col-sm-6" key={`company_address_${place.id}`}>
          <Card
            className={`${classes.card} ${classes.cardDetails}`}
            onMouseDown={() => {
              this.handlePlaceDetailOpen(place.id);
            }}
            style={{
              boxShadow: '0 3px 0 0 rgba(0, 0, 0, 0.02)',
              border: 'solid 1px #e5e5e5',
            }}
          >
            <CardHeader title={place.title} className={classes.cardHeader} />
            <CardText style={{ paddingTop: 0 }} className={classes.cardText}>
              {address}
            </CardText>
          </Card>
        </div>,
      );
    });
    return (
      <section>
        <h2>{renderTabCount(companyAddresses.length, true)} Standorte</h2>
        <div className="row">{companyAddresses}</div>
        {this.renderPlaceDetailsDialog()}
      </section>
    );
  };
  handleBankDetailOpen = id => {
    this.setState({
      selectedBankId: id,
      bankDetailDialogOpen: true,
    });
  };
  handleBankDetailClose = () => {
    this.setState({
      selectedBankId: null,
      bankDetailDialogOpen: false,
    });
  };
  renderBankDetailsDialog = () => {
    const bankId = this.state.selectedBankId;
    let bankIndex = null;
    if (typeof this.props.company.banks !== 'undefined') {
      bankIndex = _.findIndex(this.props.company.banks, ['id', bankId]);
    }
    if (
      bankIndex !== null &&
      bankIndex !== -1 &&
      typeof this.props.company.banks !== 'undefined' &&
      typeof this.props.company.banks[bankIndex] !== 'undefined'
    ) {
      const bank = this.props.company.banks[bankIndex];
      const title = bank.name;
      const actions = [
        <FlatButton
          label="Schließen"
          primary
          keyboardFocused
          onTouchTap={this.handleBankDetailClose}
        />,
      ];
      let owner = null;
      if (bank.owner !== null && bank.owner !== '') {
        owner = (
          <div>
            <h3 className={classes.detailsHeader}>Kontoinhaber</h3>
            <p>{bank.owner}</p>
          </div>
        );
      }
      let iban = null;
      if (bank.iban !== null && bank.iban !== '') {
        iban = (
          <div>
            <h3 className={classes.detailsHeader}>IBAN</h3>
            <p>{bank.iban}</p>
          </div>
        );
      }
      let bic = null;
      if (bank.bic !== null && bank.bic !== '') {
        bic = (
          <div>
            <h3 className={classes.detailsHeader}>BIC</h3>
            <p>{bank.bic}</p>
          </div>
        );
      }
      let accountNr = null;
      if (bank.account_nr !== null && bank.account_nr !== '') {
        accountNr = (
          <div>
            <h3 className={classes.detailsHeader}>Kontonummer</h3>
            <p>{bank.account_nr}</p>
          </div>
        );
      }
      let bankIdentifier = null;
      if (bank.bank_identifier !== null && bank.bank_identifier !== '') {
        bankIdentifier = (
          <div>
            <h3 className={classes.detailsHeader}>Bankleitzahl</h3>
            <p>{bank.bank_identifier}</p>
          </div>
        );
      }
      let sepaInfo = null;
      if (bank.sepa !== null && bank.sepa !== '') {
        let sepaNotes = null;
        if (bank.sepa_notes !== null && bank.sepa_notes !== '') {
          sepaNotes = <p>{nl2br(stripTags(bank.sepa_notes))}</p>;
        }
        sepaInfo = (
          <div>
            <h3 className={classes.detailsHeader}>SEPA</h3>
            <p>{bank.sepa}</p>
            {sepaNotes}
          </div>
        );
      }
      return (
        <Dialog
          title={title}
          actions={actions}
          modal
          open={this.state.bankDetailDialogOpen}
          onRequestClose={this.handleBankDetailClose}
          autoScrollBodyContent
          className="form"
          contentClassName="form-container form-container--place-detail"
          titleClassName="form-header"
          actionsContainerClassName="form-footer"
          bodyClassName="form-body"
        >
          <div className={classes.detailsSection}>
            <div className="row">
              <div className="col-sm-6">
                {owner}
                {iban}
                {bic}
              </div>
              <div className="col-sm-6">
                {accountNr}
                {bankIdentifier}
                {sepaInfo}
              </div>
            </div>
          </div>
        </Dialog>
      );
    }
  };
  handlePlaceDetailOpen = id => {
    this.setState({
      selectedPlaceId: id,
      placeDetailDialogOpen: true,
    });
  };
  handlePlaceDetailClose = () => {
    this.setState({
      selectedPlaceId: null,
      placeDetailDialogOpen: false,
    });
  };
  renderPlaceDetailsDialog = () => {
    const placeId = this.state.selectedPlaceId;
    let placeIndex = null;
    if (typeof this.props.company.company_addresses !== 'undefined') {
      placeIndex = _.findIndex(this.props.company.company_addresses, [
        'id',
        placeId,
      ]);
    }
    if (
      placeIndex !== null &&
      placeIndex !== -1 &&
      typeof this.props.company.company_addresses !== 'undefined' &&
      typeof this.props.company.company_addresses[placeIndex] !== 'undefined'
    ) {
      const place = this.props.company.company_addresses[placeIndex];
      const title = place.title;
      const actions = [
        <FlatButton
          label="Schließen"
          primary
          keyboardFocused
          onTouchTap={this.handlePlaceDetailClose}
        />,
      ];
      const address =
        typeof place.address !== 'undefined' && place.address !== null ? (
          <Address address={place.address} />
        ) : null;
      const contactDetails = [];
      let rawContactDetails = [];
      if (
        typeof place.contact_details !== 'undefined' &&
        Object.prototype.toString.call(place.contact_details) ===
          '[object Array]'
      ) {
        rawContactDetails = rawContactDetails.concat(place.contact_details);
      }
      if (
        typeof place.contactDetails !== 'undefined' &&
        Object.prototype.toString.call(place.contactDetails) ===
          '[object Array]'
      ) {
        rawContactDetails = rawContactDetails.concat(place.contactDetails);
      }
      rawContactDetails.forEach(contactDetail => {
        contactDetails.push(
          <DetailField
            label={contactDetailsStrings[contactDetail.type]}
            content={contactDetail.value}
            extra={contactDetail.note}
            key={`contact_detail_company_place_${contactDetail.id}`}
          />,
        );
      });
      return (
        <Dialog
          title={title}
          actions={actions}
          modal
          open={this.state.placeDetailDialogOpen}
          onRequestClose={this.handlePlaceDetailClose}
          autoScrollBodyContent
          className="form"
          contentClassName="form-container form-container--place-detail"
          titleClassName="form-header"
          actionsContainerClassName="form-footer"
          bodyClassName="form-body"
        >
          <div className={classes.detailsSection}>
            <h2 className={classes.detailsSectionHeader}>
              Anschrift & Kommunikation
            </h2>
            <div className="row">
              <div className="col-sm-6">
                <h3 className={classes.detailsHeader}>Adresse</h3>
                <p>{address}</p>
              </div>
              <div className="col-sm-6">
                <h3 className={classes.detailsHeader}>Kommunikation</h3>
                <p>{contactDetails}</p>
              </div>
            </div>
          </div>

          <div className={classes.detailsSection}>
            <h2 className={classes.detailsSectionHeader}>
              Zusätzliche Informationen
            </h2>
            <div className="row">
              <div className="col-sm-6">
                <h3 className={classes.detailsHeader}>Art des Betriebes</h3>
                <p>{place.type}</p>
              </div>

              <div className="col-sm-6">
                <h3 className={classes.detailsHeader}>
                  Handelsregistereintrag
                </h3>
                <p>{place.register_entry}</p>
              </div>

              <div className="col-sm-6">
                <h3 className={classes.detailsHeader}>Betriebsgründung</h3>
                <p>
                  {typeof place.foundation !== 'undefined' &&
                  place.foundation !== null &&
                  place.foundation.length
                    ? `${moment(place.foundation, 'YYYY-MM-DD').format(
                        'DD. MM. YYYY',
                      )}`
                    : null}
                </p>
              </div>

              <div className="col-sm-6">
                <h3 className={classes.detailsHeader}>Betriebsleiter</h3>
                <p>{place.ceo_fullname}</p>
              </div>

              <div className="col-sm-12">
                <h3 className={classes.detailsHeader}>Bemerkungen</h3>
                <p
                  dangerouslySetInnerHTML={{
                    __html: nl2br(stripTags(place.notes)),
                  }}
                />
              </div>
            </div>
          </div>
        </Dialog>
      );
    }
  };
  renderBanks = () => {
    const banks = [];
    if (
      typeof this.props.company.banks === 'undefined' ||
      this.props.company.banks.length === 0
    ) {
      return (
        <p className="text-center">
          <small>Dieses Unternehmen hat noch keine Bankdaten.</small>
        </p>
      );
    }
    const sortedBanks = sortArray(this.props.company.banks, 'created_at', true);
    sortedBanks.forEach(bank => {
      if (bank.name.length === 0) {
        return;
      }
      banks.push(
        <div className="col-xs-12 col-sm-6" key={`company_banks_${bank.id}`}>
          <Card
            className={`${classes.card} ${classes.cardDetails}`}
            onMouseDown={() => {
              this.handleBankDetailOpen(bank.id);
            }}
            style={{
              boxShadow: '0 3px 0 0 rgba(0, 0, 0, 0.02)',
              border: 'solid 1px #e5e5e5',
            }}
          >
            <CardHeader title={bank.name} className={classes.cardHeader} />
            <CardText style={{ paddingTop: 0 }} className={classes.cardText}>
              {bank.owner}
              <br />
              {bank.iban}
              <br />
              {bank.bic}
            </CardText>
          </Card>
        </div>,
      );
    });
    return (
      <section>
        <h2>{renderTabCount(this.props.company.banks, true)} Bankdaten</h2>
        <div className="row">{banks}</div>
        {this.renderBankDetailsDialog()}
      </section>
    );
  };
  renderContactDetails = () => {
    const details = [];
    this.props.company.contact_details.forEach(contactDetail => {
      // key={`contact_detail_${contactDetail.id}`}
      details.push(
        <DetailField
          label={contactDetailsStrings[contactDetail.type]}
          content={contactDetail.value}
          extra={contactDetail.note}
          key={`contact_detail_company_${contactDetail.id}`}
        />,
      );
    });
    return details;
  };
  renderLogo = (width, height, fit) => {
    width = typeof width === 'undefined' ? 200 : width;
    height = typeof height === 'undefined' ? 200 : height;
    fit = typeof fit === 'undefined' ? 'crop' : fit;
    if (this.props.company.logo !== null) {
      return (
        <div>
          <img
            src={`${simplImageUrl()}${
              this.props.company.logoPath
            }?w=${width}&h=${height}&fit=${fit}`}
          />
        </div>
      );
    }
    return null;
  };

  renderNumbers = type => {
    const numberFields = [];

    if (type.includes('Kunde')) {
      numberFields.push(
        <DetailField
          label="Kundennummer"
          content={this.props.company.meta.customer_no}
          key={`customer_no`}
        />,
        <DetailField
          label="Kundennummer extern"
          content={this.props.company.meta.customer_no_extern}
          key={`customer_no_extern`}
        />,
      );
    }

    if (type.includes('Lieferant')) {
      numberFields.push(
        <DetailField
          label="Lieferantennummer"
          content={this.props.company.meta.supplier_no}
          key={`supplier_no`}
        />,
        <DetailField
          label="Lieferantennummer extern"
          content={this.props.company.meta.supplier_no_extern}
          key={`supplier_no_extern`}
        />,
      );
    }

    if (type.includes('Institution')) {
      numberFields.push(
        <DetailField
          label="Institutionsnummer"
          content={this.props.company.meta.institutor_no}
          key={`institutor_no`}
        />,
        <DetailField
          label="Institutionsnummer extern"
          content={this.props.company.meta.institutor_no_extern}
          key={`institutor_no_extern`}
        />,
      );
    }

    return numberFields;
  };

  renderOverview = () => {
    const companyType = this.props.company.type;
    let type = '';
    if (
      companyType !== null &&
      typeof companyType === 'object' &&
      Object.keys(companyType).length
    ) {
      companyType.forEach((currentType, index) => {
        if (companyType.length > 1 && index !== companyType.length - 1) {
          type += `${companyStrings[currentType]}, `;
        } else {
          type += companyStrings[currentType];
        }
      });
    }
    let address = null;
    if (
      typeof this.props.company.addresses !== 'undefined' &&
      this.props.company.addresses &&
      this.props.company.addresses.length &&
      typeof this.props.company.addresses[0] !== 'undefined' &&
      this.props.company.addresses[0].street &&
      this.props.company.addresses[0].street.length
    ) {
      const ad = this.props.company.addresses[0];
      address = (
        <div className="row overview">
          <div className="col-xs-12 col-sm-3">
            <label>Adresse</label>
          </div>
          <div className="col-xs-12 col-sm-9">
            <Address address={ad} />
          </div>
        </div>
      );
    }
    let communicationSection = '';
    if (address || this.renderContactDetails().length) {
      communicationSection = (
        <section>
          <h2>Anschrift & Kommunikation</h2>
          {address}

          {this.renderContactDetails()}
        </section>
      );
    }
    return (
      <div>
        <section>
          <h2>Allgemein</h2>

          <DetailField label="Name" content={this.props.company.name} />

          <DetailField
            label="Kurzbezeichnung"
            content={this.props.company.short_name}
          />

          <DetailField label="Typ" content={type} />
          {this.props.company.is_my_company ? (
            <DetailField label="Typ" content="Dies ist Ihr Unternehmen" />
          ) : null}

          {/* <DetailField */}
          {/* label='Logo' */}
          {/* content={this.renderLogo(300, 200, 'contain')} */}
          {/* /> */}

          {this.renderNumbers(type)}
        </section>

        {communicationSection}

        <section>
          <h2>Zusätzliche Informationen</h2>

          <DetailField
            label="Rechtsform"
            content={this.props.company.meta.legal_form}
          />
          <DetailField
            label="Branche"
            content={this.props.company.meta.industry}
          />
          <DetailField
            label="Handelsregistereintrag"
            content={this.props.company.meta.trade_register_entry}
          />
          <DetailField
            label="Steuernummer"
            content={this.props.company.meta.tax_number}
          />
          <DetailField
            label="UST-ID-Nummer"
            content={this.props.company.meta.vat_number}
          />
          <DetailField
            label="Gründungsdatum"
            content={this.props.company.meta.foundation_date}
          />
          <DetailField
            label="Bemerkungen"
            content={this.props.company.meta.notes}
            className="notes"
          />
        </section>
      </div>
    );
  };
  render() {
    if (!this.props.company || Object.keys(this.props.company).length === 0) {
      // no data loaded yet
      return <div />;
    }
    Tabs.setUseDefaultStyles(false);
    const company = this.props.company;
    return (
      <div
        className={
          this.props.company.deleted_at === null
            ? 'wrapper details-view'
            : 'wrapper details-view deletedModel'
        }
      >
        {this.renderHeader()}
        <Tabs
          onSelect={this.handleSelect}
          selectedIndex={this.state.selectedIndex}
          className="content"
        >
          <TabList activeTabClassName="active">
            <Tab>
              <span>Details</span>
            </Tab>
            <Tab>
              <span>Kontakte {renderTabCount(this.props.persons)}</span>
            </Tab>
            <Tab>
              <span>Standorte {renderTabCount(company.company_addresses)}</span>
            </Tab>
            <Tab>
              <span>Bankdaten {renderTabCount(company.banks)}</span>
            </Tab>
            <Tab>
              <span>Aktivitäten {renderTabCount(this.props.activities)}</span>
            </Tab>
            <Tab>
              <span>
                Beteiligte Aktivitäten{' '}
                {renderTabCount(this.props.activitiesInvolved)}
              </span>
            </Tab>
            <Tab>
              <span>Projekte {renderTabCount(this.props.projects)}</span>
            </Tab>
            <Tab>
              <span>Aufgaben {renderTabCount(this.props.tasks)}</span>
            </Tab>
            <Tab>
              <span>Dateien {renderTabCount(this.props.files)}</span>
            </Tab>
          </TabList>

          <TabPanel>{this.renderOverview()}</TabPanel>
          <TabPanel>
            <div>{this.renderContacts()}</div>
          </TabPanel>
          <TabPanel>
            <div>{this.renderPlaces()}</div>
          </TabPanel>
          <TabPanel>
            <div>{this.renderBanks()}</div>
          </TabPanel>
          <TabPanel>
            <ActivityTableEmbed
              activities={this.props.activities}
              staffs={this.props.staffs}
              compact
            />
          </TabPanel>
          <TabPanel>
            <ActivityTableEmbed
              activities={this.props.activitiesInvolved}
              staffs={this.props.staffs}
              compact
              title="Beteiligte Aktivitäten"
            />
          </TabPanel>
          <TabPanel>
            <section>
              <h2>{renderTabCount(this.props.projects, true)} Projekte</h2>
            </section>
            <section className="no-padding">
              <ProjectTableEmbed
                projects={this.props.projects}
                staffs={this.props.staffs}
              />
            </section>
          </TabPanel>
          <TabPanel>
            <section>
              <h2>{renderTabCount(this.props.tasks, true)} Aufgaben</h2>
            </section>
            <TaskList
              tasks={this.props.tasks}
              showTaskForm
              taskableType="company"
              taskableId={this.props.company.id}
              showFutureDates
            />
          </TabPanel>
          <TabPanel>
            <section>
              <h2>{renderTabCount(this.props.files, true)} Dateien</h2>
            </section>
            <section className="no-padding">
              <FileTable
                files={this.props.files}
                deleteFile={this.props.deleteFile}
              />
            </section>
          </TabPanel>
        </Tabs>

        <FormFileUpload
          attachableId={this.props.company.id}
          attachableType="App\Company"
          files={[]}
          onUpdate={() => {
            this.props.fetchCompany(this.props.company.id);
          }}
          invisible
          disabled={this.props.formOpen}
        />
      </div>
    );
  }
}
Company.propTypes = {
  fetchCompany: PropTypes.func.isRequired,
  setCompany: PropTypes.func.isRequired,
  deleteCompany: PropTypes.func.isRequired,
  setCompanyForm: PropTypes.func.isRequired,
  deleteFile: PropTypes.func.isRequired,
  restoreObject: PropTypes.func.isRequired,
  push: PropTypes.func.isRequired,
  company: PropTypes.object,
  companyCount: PropTypes.number,
  activities: PropTypes.array.isRequired,
  activitiesInvolved: PropTypes.array.isRequired,
  files: PropTypes.array,
  tasks: PropTypes.array,
  staffs: PropTypes.array,
  persons: PropTypes.array,
  projects: PropTypes.array,
  params: PropTypes.object,
  router: PropTypes.object,
  formOpen: PropTypes.bool,
};
export default withRouter(Company);



// WEBPACK FOOTER //
// ./src/routes/CompanyDetail/components/Company.js